import { createFileRoute } from "@tanstack/react-router";

import { publicSpecDetailsSearchSchema } from "@/api/contracts/share-public";
import { PublicSpecDetailsPage } from "@/components/specifications/public-spec-details-page";
import { PublicSpecLayout } from "@/components/specifications/public-spec-layout";
import { publicShareHead } from "@/lib/share-token";
import { specSearchNavigation } from "@/lib/spec-lines-display";

// **The pinned public details page** — `/public-spec/:specId/versions/:versionId
// ?share_token=…`, a "This version" share link and the resolver's landing
// (#1024; ADR-0019). Top-level and outside `_authed/`: whoever holds the link
// reaches it with no session, and a signed-in visitor is a share visitor here
// (`system.md` §3.1, carve-out 3). Named in `routes-layout.unit.test.ts`'s
// public directory pins; more specific than `public-spec/$`, which answers
// every other `/public-spec/…` path with Page not found.
//
// The public layout's spec face (Copy Link and Print) around the page, which
// reads on the client: the source draws the header over an empty body while
// its metadata read is in flight, which a loader would skip.
export const Route = createFileRoute("/public-spec/$specId/versions/$versionId")({
  head: publicShareHead,
  validateSearch: publicSpecDetailsSearchSchema,
  // The donor's app restores no scroll and its public layout never writes the
  // window (`@/lib/router-scroll`), so the router stands down here too: a line
  // search keeps the window where the reader left it.
  staticData: { leavesScrollToBrowser: true },
  component: PublicSpecDetailsRoute,
});

function PublicSpecDetailsRoute() {
  const { specId, versionId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PublicSpecLayout share={{ specId, versionId }}>
      <PublicSpecDetailsPage
        specId={specId}
        versionId={versionId}
        search={search}
        onSearchChange={(term) => void navigate(specSearchNavigation(term))}
      />
    </PublicSpecLayout>
  );
}
